
import React, { useEffect, useState } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';

import TabContext from '@mui/lab/TabContext';
import Box from '@mui/material/Box';
import TabPanel from '@mui/lab/TabPanel';
import { Can } from '../../Context/Can';
import ManageMeters from './ManageMeters';
import CalibrationReport from './CalibrationReport';

import { useSelector } from 'react-redux';
import OnlineMonitoring from './OnlineMonitoring';
import CalibrationList from './CalibrationList';
import TrendingAnalysis from './TrendingAnalysis';
import { CircularProgress, Grid, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { tabListStyle, tabStyle } from '../../theme/formStyles';


export default function MeterCommon() {
    const { client_id, tabId, id } = useParams();
    const pid = Number(id);
    const navigate = useNavigate();
    const [value, setValue] = useState('1');
    const [showLoader, setShowLoader] = useState(true);
    const [isSpoc, setIsSpoc] = useState(null);

    const state = useSelector(st => st)
    const {role} = state;

    const meterQueryParams = localStorage.getItem("meterQueryParams");

    useEffect(() => {
        if (role?.data?.data) {
            const hasSpocRole = role.data.data.some(item => item.role === 'spoc')
            setIsSpoc(hasSpocRole)
            setShowLoader(false);
        }
    }, [role]);

    useEffect(() => {
        setValue(tabId)
      }, [tabId]);

    const handleTabSwitch = (event, newValue) => {
        setValue(newValue);
        navigate(`/client/${client_id}/meters/${newValue}/${pid}`)
      };    

    const tabNames = ['trending-analysis', 'online-monitoring', 'calibration-report', 'edit', 'view'];

    let found = false;
    for (const tabName of tabNames) {
        if (window.location.pathname.includes(tabName)) {
            found = true;
            break;
        }
    }

    if (!found) {
        navigate('/page-not-found');
    }

    if (showLoader) {
        return <Grid container>
            <Grid style={{display: 'flex', justifyContent: 'center', width: '100vw', height: '500px',  alignItems: 'center' }}>
                <CircularProgress />
            </Grid>
        </Grid>
    }

    return <>
        <div className='w3-padding-large'>
            <div >
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center' }}>
                            <IconButton 
                            onClick={() => meterQueryParams ? navigate(`/client/${client_id}/meters?${meterQueryParams?.toString()}`) : navigate(`/client/${client_id}/meters`)}
                            color="inherit">
                                <ArrowBackIosIcon fontSize='small'/>
                            </IconButton>
                            <TabList onChange={handleTabSwitch} aria-label="lab API tabs example" sx={tabListStyle}>
                                <Tab label="Trending Analysis" value="trending-analysis" sx={tabStyle} />
                                <Tab label="Online Monitoring" value="online-monitoring" sx={tabStyle} />
                                <Tab label="Calibration Report" value="calibration-report" sx={tabStyle} />
                                <Tab 
                                    label={isSpoc ? "View Meter" : "Edit Meter"}
                                    value={isSpoc ? "view" : "edit"} sx={tabStyle} />
                            </TabList>
                        </Box>
                        <TabPanel style={{ padding: '0px' }} value="trending-analysis"><Can I="view" a="TrendingAnalysis"><TrendingAnalysis /></Can> </TabPanel>
                        <TabPanel style={{ padding: '0px' }} value="online-monitoring"><Can I="view" a="OnlineMonitoring"><OnlineMonitoring /></Can> </TabPanel>
                        <TabPanel style={{ padding: '0px' }} value="calibration-report"><Can I="view" a="CalibrationReport"><CalibrationList /> </Can></TabPanel>
                        <TabPanel style={{ padding: '0px' }} value={isSpoc ? "view" : "edit"}><Can I="view" a="Meter"><ManageMeters isSpoc={isSpoc} /></Can> </TabPanel>
                    </TabContext>
                </Box>
            </div>
        </div>
    </>
}